
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getStatHourCurve } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiHomeModalEchart extends Vue {
  private title = "";
  private modalEchart: objAny = {};
  private myChart: objAny = {};
  private myChartData: objAny = {
    time: [],
    data: []
  };
  private formData: objAny = {};
  private win: objAny = window;

  public open(data: objAny) {
    this.title = data.title;
    this.formData = data.formData;
    this.modalShow = true;
    this.$nextTick(() => {
      this.modalEchart = this.$refs["modalEchart"];
      this.getStatHourCurve();
    });
  }

  async getStatHourCurve(): Promise<void> {
    const json: objAny = {};
    for (const i in this.formData) {
      json[i] = this.formData[i] == "" ? null : this.formData[i];
    }
    const ret = await getStatHourCurve(json);
    if (ret.status === this.$config.apiStatus) {
      const time: string[] = [];
      const value: string[] = [];
      ret.data.map((item: objAny) => {
        time.push(item.name + i18n.t("home.hour"));
        value.push(item.value);
      });
      this.myChartData.time = time;
      this.myChartData.data = value;
      this.echartShow();
    }
  }

  public echartShow(): void {
    const option = {
      xAxis: {
        type: "category",
        data: this.myChartData.time
      },
      grid: {
        bottom: "10%",
        top: "10%"
      },
      tooltip: {
        trigger: "axis"
      },
      color: ["#6ed0ba"],
      yAxis: {
        type: "value"
      },
      series: [
        {
          data: this.myChartData.data,
          type: "line",
          smooth: true,
          name: this.title
        }
      ]
    };
    this.myChart = this.win.echarts.init(this.modalEchart);
    this.myChart.clear();
    this.myChart.setOption(option, true);
  }

  private modalShow = false;
}
